export const PASSWORDINPUT_UNIQUE_ID_PREFIX = "fs-passwordinput";
